// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/instance.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/instance.proto.
 */
export const file_agentplatform_v1_instance: GenFile = /*@__PURE__*/
  fileDesc("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", [file_gnostic_openapi_v3_annotations, file_google_api_field_behavior]);

/**
 * @generated from message infinigence.infini.agentplatform.v1.InstanceSubresource
 */
export type InstanceSubresource = Message<"infinigence.infini.agentplatform.v1.InstanceSubresource"> & {
  /**
   * 子资源类型
   * @gotags: json:"type,omitempty"
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * 子资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * 子资源名称
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.InstanceSubresource.
 * Use `create(InstanceSubresourceSchema)` to create a new message.
 */
export const InstanceSubresourceSchema: GenMessage<InstanceSubresource> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_instance, 0);

/**
 * 定义实例
 *
 * @generated from message infinigence.infini.agentplatform.v1.Instance
 */
export type Instance = Message<"infinigence.infini.agentplatform.v1.Instance"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 实例名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 实例描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 4 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 5 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 智能体编号
   * @gotags: json:"agent_id"
   *
   * @generated from field: string agent_id = 6 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * Vibe Agent ID
   * @gotags: json:"vibe_agent_id,omitempty"
   *
   * @generated from field: string vibe_agent_id = 7 [json_name = "vibe_agent_id"];
   */
  vibeAgentId: string;

  /**
   * @gotags: json:"vibe_instance_id,omitempty"
   *
   * @generated from field: string vibe_instance_id = 8 [json_name = "vibe_instance_id"];
   */
  vibeInstanceId: string;

  /**
   * 实例参数
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: map<string, string> params = 9;
   */
  params: { [key: string]: string };

  /**
   * 子资源列表
   * @gotags: json:"subresources,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.InstanceSubresource subresources = 10;
   */
  subresources: InstanceSubresource[];

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 11 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 12 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 13 [json_name = "deleted_at"];
   */
  deletedAt: bigint;

  /**
   * 实例创建/更新时的模版配置哈希
   * @gotags: json:"config_hash,omitempty"
   *
   * @generated from field: string config_hash = 14 [json_name = "config_hash"];
   */
  configHash: string;

  /**
   * 配置同步状态
   * @gotags: json:"config_sync_status,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ConfigSyncStatus config_sync_status = 15 [json_name = "config_sync_status"];
   */
  configSyncStatus: ConfigSyncStatus;

  /**
   * 运行状态（不存DB，API响应时从VibeAgent实时填充）
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.InstanceStatus status = 16;
   */
  status: InstanceStatus;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Instance.
 * Use `create(InstanceSchema)` to create a new message.
 */
export const InstanceSchema: GenMessage<Instance> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_instance, 1);

/**
 * @generated from message infinigence.infini.agentplatform.v1.InstanceStatusResponse
 */
export type InstanceStatusResponse = Message<"infinigence.infini.agentplatform.v1.InstanceStatusResponse"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.InstanceStatus status = 2;
   */
  status: InstanceStatus;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.InstanceStatusResponse.
 * Use `create(InstanceStatusResponseSchema)` to create a new message.
 */
export const InstanceStatusResponseSchema: GenMessage<InstanceStatusResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_instance, 2);

/**
 * 配置同步状态
 *
 * @generated from enum infinigence.infini.agentplatform.v1.ConfigSyncStatus
 */
export enum ConfigSyncStatus {
  /**
   * 未指定（历史数据兼容）
   *
   * @generated from enum value: CONFIG_SYNC_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 同步：实例与模版 configurable 参数一致
   *
   * @generated from enum value: CONFIG_SYNC_STATUS_SYNCED = 1;
   */
  SYNCED = 1,

  /**
   * 需要更新：模版 configurable 参数已变更，实例需要更新
   *
   * @generated from enum value: CONFIG_SYNC_STATUS_OUTDATED = 2;
   */
  OUTDATED = 2,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.ConfigSyncStatus.
 */
export const ConfigSyncStatusSchema: GenEnum<ConfigSyncStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_instance, 0);

/**
 * 实例状态
 *
 * @generated from enum infinigence.infini.agentplatform.v1.InstanceStatus
 */
export enum InstanceStatus {
  /**
   * 实例待启动
   *
   * @generated from enum value: INSTANCE_STATUS_PENDING = 0;
   */
  PENDING = 0,

  /**
   * 实例已启动
   *
   * @generated from enum value: INSTANCE_STATUS_RUNNING = 1;
   */
  RUNNING = 1,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.InstanceStatus.
 */
export const InstanceStatusSchema: GenEnum<InstanceStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_instance, 1);

